module.exports = __webpack_public_path__ + "img/pontotel-branco.08aba9ca.png";